import {
  Box,
  CssBaseline,
  Drawer,
  List,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import logo from "../../../assets/images/Nurture Logo.png";
import smallLogo from "../../../assets/images/smallLogo.svg";
import AppRouter from "../../../router/AppRouter";
import { SideBar } from "./../../../components/SideBar/SideBar";
import AppHeader from "./AppHeader";
import styles from "./Home.module.css";
import selectedHomeIcon from "../../../assets/images/selectedHomeIcon.svg";
import unselectedHomeIcon from "../../../assets/images/unselectedHomeIcon.svg";
import selectedInboundIcon from "../../../assets/images/selectedInboundIcon.svg";
import unselectedInboundIcon from "../../../assets/images/unselectedInboundIcon.svg";
import selectedReportIcon from "../../../assets/images/selectedReportIcon.svg";
import unselectedReportIcon from "../../../assets/images/unselectedReportIcon.svg";
// import selectedNurtureIcon from "../../../assets/images/selectedNurtureIcon.svg";
// import unselectedNurtureIcon from "../../../assets/images/unselectedNurtureIcon.svg";
import selectedTaskIcon from "../../../assets/images/selectedTaskIcon.svg";
import unselectedTaskIcon from "../../../assets/images/unselectedTaskIcon.svg";
import navBarButton from "../../../assets/images/navBarButton.svg";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import { useMediaQuery, useTheme } from "@mui/material";
import selectedIntegrationIcon from "../../../assets/images/selectedIntegrationIcon.svg";
import unselectedIntegrationIcon from "../../../assets/images/unselectedIntegrationIcon.svg";
// import selectedStudent from "../../../assets/images/studentActive.svg";
// import unselectedStudent from "../../../assets/images/studentInactive.svg";
import selectedSettingsIcon from "../../../assets/images/selectedSettingsIcon.svg";
import unselectedSettingsIcon from "../../../assets/images/unselectedSettingsIcon.svg";
import getAccessStatus, {
  checkAccess,
  getSubDomainAccessStatus,
} from "../../../components/RolePermissionAccess/RolePermissionAccess";
import LeadPopup from "../../../components/LeadPopup/LeadPopup";
import MainLoader from "../../../components/MainLoader/MainLoader";
import attendanceSelected from "../../../assets/images/attendanceSelected.svg";
import { useDispatch } from "react-redux";
import { setCompress, toggleCompresser } from "./service/compressorSlice";
import attendanceNotSelected from "../../../assets/images/attendanceNotSelected.svg";
import PaymentsActive from "../../../assets/images/PaymentsActive.svg";
import PaymentsInactive from "../../../assets/images/PaymentsInactive.svg";
import selectedNurtureIcon from "../../../assets/images/SelectedNurtureTabIcon.svg";
import unselectedNurtureIcon from "../../../assets/images/NurtureTabIcon.svg";
import selectedStudent from "../../../assets/images/ActiveStudents.svg";
import unselectedStudent from "../../../assets/images/Students.svg";
import ViewContact from "../../../components/ViewContact/ViewContact";
import { GetBanner } from "../Dashboard/service/dashboard.request";

const drawerWidth = 200;
const compressDrawerWidth = 70;
const appVersion = process.env.REACT_APP_VERSION;
const appEnv = process.env.REACT_APP_ENV;

export default function Main(props: any) {
  const auth = useAuthUser();
  const authUser = auth();
  const theme = useTheme();
  const isTabSize = useMediaQuery(theme.breakpoints.down("md"));
  const loggedIn = useSelector((state: any) => state?.activeInstitute?.success);
  const { leadModalState } = useSelector((state: any) => state.nurture);
  const userFromLocalStorage = JSON.parse(
    localStorage.getItem("ACTIVE_INSTITUTE")!
  );

  const [mobileOpen, setMobileOpen] = React.useState(true);
  const [menuData, setMenuData] = React.useState<string>("Home");
  const [width, setWidth] = React.useState<number>(window.innerWidth);
  const [isActive, setIsActive] = useState(0);
  const dispatch = useDispatch();
  const isCompress = useSelector((state: any) => state.compress.isCompress);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  const { userById } = useSelector((state: any) => state.userDetails);
  const { contactModalState } = useSelector((state: any) => state.institute);

  const sideBarNavItem = [
    {
      text: "Home",
      icon: isActive === 0 ? selectedHomeIcon : unselectedHomeIcon,
      to:
        userFromLocalStorage?.isProfileCompleted ||
        userFromLocalStorage?.instituteDetails?.isProfileCompleted
          ? "dashboard"
          : "home",
      color: isActive === 0 ? "#11C89B" : "#8A94A6",
      access: true,
    },
    {
      text: "Inbound",
      icon: isActive === 1 ? selectedInboundIcon : unselectedInboundIcon,
      to: getSubDomainAccessStatus(
        "INBOUND",
        "CONTACTS",
        "VIEW_ONLY",
        userById?.rolePermission
      )
        ? "Inbound"
        : getSubDomainAccessStatus(
            "INBOUND",
            "EMAIL",
            "VIEW_ONLY",
            userById?.rolePermission
          )
        ? "Inbound/Email"
        : getSubDomainAccessStatus(
            "INBOUND",
            "IMPORT",
            "VIEW_ONLY",
            userById?.rolePermission
          )
        ? "Inbound/Import"
        : getSubDomainAccessStatus(
            "INBOUND",
            "WEBFORMS",
            "VIEW_ONLY",
            userById?.rolePermission
          )
        ? "Inbound/Webforms"
        : getSubDomainAccessStatus(
            "INBOUND",
            "ZAPIER",
            "VIEW_ONLY",
            userById?.rolePermission
          )
        ? "Inbound/Zapier"
        : "Inbound",
      color: isActive === 1 ? "#11C89B" : "#8A94A6",
      access: checkAccess("INBOUND", userById?.rolePermission),
    },
    {
      text: "Nurture",
      icon: isActive === 2 ? selectedNurtureIcon : unselectedNurtureIcon,
      to: "Nurture",
      color: isActive === 2 ? "#11C89B" : "#8A94A6",
      access: getSubDomainAccessStatus(
        "NURTURE_BOARD",
        "BOARD",
        "BOARD_ACCESS",
        userById?.rolePermission
      ),
    },
    {
      text: "Tasks",
      icon: isActive === 3 ? selectedTaskIcon : unselectedTaskIcon,
      to: getAccessStatus(
        "TASKS",
        "ALL_OTHER_USERS'_TASK",
        userById?.rolePermission
      )
        ? `Tasks?selectedUsers=${authUser?.institute?.[0]?.id}`
        : `Tasks`,
      color: isActive === 3 ? "#11C89B" : "#8A94A6",
      access: true,
    },
    {
      text: "Students",
      icon: isActive === 4 ? selectedStudent : unselectedStudent,
      to: "Students",
      color: isActive === 4 ? "#11C89B" : "#8A94A6",
      access: checkAccess("STUDENTS", userById?.rolePermission),
    },
    {
      text: "Transactions",
      icon: isActive === 5 ? PaymentsActive : PaymentsInactive,
      to: "Transactions",
      color: isActive === 5 ? "#11C89B" : "#8A94A6",
      access: checkAccess("REPORT", userById?.rolePermission),
    },
    {
      text: "Attendance",
      icon: isActive === 6 ? attendanceSelected : attendanceNotSelected,
      to: "Attendance",
      color: isActive === 6 ? "#11C89B" : "#8A94A6",
      access: checkAccess("ATTENDANCE", userById?.rolePermission),
    },

    {
      text: "Reports",
      icon: isActive === 7 ? selectedReportIcon : unselectedReportIcon,
      to: "Reports",
      color: isActive === 7 ? "#11C89B" : "#8A94A6",
      access: checkAccess("REPORT", userById?.rolePermission),
    },
    {
      text: "Integrations",
      icon:
        isActive === 8 ? selectedIntegrationIcon : unselectedIntegrationIcon,
      to: "Integrations",
      color: isActive === 8 ? "#11C89B" : "#8A94A6",
      access: checkAccess("INTEGRATIONS", userById?.rolePermission),
    },

    {
      text: "Settings",
      icon: isActive === 9 ? selectedSettingsIcon : unselectedSettingsIcon,
      to: "Settings",
      color: isActive === 9 ? "#11C89B" : "#8A94A6",
      access: checkAccess("SETTINGS", userById?.rolePermission),
    },
  ];
  const toggleCompress = () => {
    dispatch<any>(toggleCompresser());
  };

  const handleCompress = React.useCallback(
    (item: boolean) => {
      setCompress(item);
    },
    [setCompress]
  );

  const handleDrawerToggle = React.useCallback(() => {
    setMobileOpen(!mobileOpen);
  }, [mobileOpen]);
  const drawer = (
    <div>
      <Toolbar />
      <List style={{ color: "#ffffff" }}>
        {sideBarNavItem.map((item, index) => (
          <SideBar
            key={Math.random()}
            setIsActive={setIsActive}
            index={index}
            setMenuData={setMenuData}
            isActive={isActive}
            item={item}
            isCompress={isCompress}
            itemAccess={item?.access}
          />
        ))}
      </List>
    </div>
  );

  useEffect(() => {
    if (window.location.href.includes("Nurture")) {
      setIsActive(2);
      setCompress(true);
    } else {
      setCompress(false);
    }
  }, []);

  useEffect(() => {
    const { href } = window.location;
    if (
      href.includes("inbound") ||
      href.includes("Inbound/EmailIntegration/EmailSyncing") ||
      href.includes("Inbound/Contacts") ||
      href.includes("Inbound/Email") ||
      href.includes("Inbound/Webforms")
    ) {
      setIsActive(1);
    } else if (href.includes("tasks")) {
      setIsActive(3);
    } else if (href.includes("students")) {
      setIsActive(4);
    } else if (href.includes("Transactions")) {
      setIsActive(5);
    } else if (
      href.includes("Reports") ||
      href.includes("Reports/AttendanceReportCreation")
    ) {
      setIsActive(7);
    } else if (href.includes("Attendance")) {
      setIsActive(6);
    } else if (href.includes("Integrations")) {
      setIsActive(8);
    } else if (
      href.includes("Settings") ||
      href.includes("app/Settings") ||
      href.includes("Settings/Invoices") ||
      href.includes("Settings/Notifications") ||
      href.includes("Settings/EmailTemplates")
    ) {
      setIsActive(9);
    } else if (href.includes("manage") || href.includes("dashboard")) {
      setIsActive(0);
    }
  }, [window.location.href]);

  useEffect(() => {
    if (isTabSize) {
      setCompress(true);
    }
  }, []);

  React.useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <CssBaseline />

      <Box
        className={styles.menuDrawer}
        component="nav"
        sx={{
          width: {
            sm: isTabSize
              ? compressDrawerWidth
              : !isCompress
              ? drawerWidth
              : compressDrawerWidth,
          },

          position: "relative",
          flexShrink: { sm: 0 },
          backgroundColor: "#1A3235",
          transition: ".1s ease-in-out",
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          PaperProps={{ sx: { backgroundColor: "#142C44" } }}
          variant={"permanent"}
          sx={{
            transition: ".1s ease-in-out",
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: !isCompress ? drawerWidth : compressDrawerWidth,
              transition: ".1s ease-in-out",
              display: "flex",
              justifyContent: "space-between",
            },
          }}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {!isCompress ? (
            <Box className={styles.logo_box}>
              <img src={logo} alt="" />
            </Box>
          ) : (
            <Box className={styles.logo_box_small} sx={{ ml: "7px" }}>
              <img src={smallLogo} height="32" width="32" alt="" />
            </Box>
          )}

          {drawer}

          {appEnv !== "prod" && (
            <Typography
              variant="h6"
              sx={{
                fontSize: 10,
                color: "#fff",
                paddingLeft: "10px",
              }}
            >
              {appEnv}
              {appVersion}
            </Typography>
          )}
        </Drawer>
        <button
          className={
            isCompress
              ? styles.mainSidebarCompressBtnisCompress
              : styles.mainSidebarCompressBtn
          }
          onClick={toggleCompress}
          style={{
            transition: ".3s ease-in-out",
            zIndex: contactModalState ? 999999 : 9999999,
          }}
        >
          <img src={navBarButton} height="30" width="30" alt="" />
        </button>
      </Box>

      <Box sx={{ flexGrow: 1, overflowX: "hidden", position: "relative" }}>
        <AppHeader
          handleDrawerToggle={handleDrawerToggle}
          name={menuData}
          loggedIn={loggedIn}
        />
        <Box
          sx={{
            backgroundColor: "#F5F5F5",
            maxHeight: "calc(100vh - 65px)",
            minHeight: "calc(100vh - 65px)",
            // position: "relative",
          }}
        >
          {userById === null ? (
            <MainLoader />
          ) : (
            <>
              {leadModalState && <LeadPopup />}
              {contactModalState && <ViewContact />}
              <AppRouter handleCompress={handleCompress} />
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
